import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const fullNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) return null;

  const parts = value.trim().split(/\s+/);
  return parts.length >= 2 ? null : { fullName: true };
};
